import React, { useEffect, useState } from "react"
import List from "../../../components/List/List"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useGetCategory } from "../../../hooks/Category/useGetCategory"
import { useGetCombo } from "../../../hooks/Combo/useGetCombo"
import { ComboEntity } from "../../../Objects/Combo/ComboEntity"
import { comboMemory } from "../../../Objects/Memory/Memory"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import { ComboPopup } from "./ComboPopup"
import { CatalogProductEntity } from "../../../Objects/ProductsAndCatalogItems/CatalogProductEntity"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"
import { useTranslation } from "react-i18next"
import { ImportDataPopup } from "../../../components/DataImport/ImportDataPopup"

export const ComboPage: React.FC = () => {
  const { t } = useTranslation(["combo", "list", "dataImport"])

  const [enableCombo, setEnableCombo] = useState(false)

  const [enableImport, setEnableImport] = useState(false)

  const [combo, setCombo] = useState<ComboEntity | undefined>(undefined)

  const { handleGetCategory } = useGetCategory()

  const { handleGetCombo } = useGetCombo()

  useEffect(() => {
    const loadData = async () => {
      await handleGetCategory(async () => await handleGetCombo(() => {}))
    }

    loadData()
  }, [])

  const handleSwitch = (status: boolean) => {
    setCombo(undefined)

    setEnableCombo(status)
  }

  useOnboardingCreatePopup(() => handleSwitch(true))

  const handleCopyCombo = () => {
    if (!combo) {
      return
    }

    setCombo(
      new ComboEntity({
        ...combo,
        id: -1,
        catalogProductEntity: new CatalogProductEntity({
          ...combo.catalogProductEntity,
          id: -1,
          iconUrl: "",
        }),
      }),
    )
  }

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          enableLocalPagination
          data={comboMemory.getListCards(true)}
          messageCount={t("list:label_combo_page_message_count")}
          messageEmpty={t("list:label_combo_page_message_empty")}
          nameFindSearch={t("list:label_combo_page_place_holder")}
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          handleAddButton={() => handleSwitch(true)}
          handleImportFloatButton={() => setEnableImport(true)}
          handleRefreshButton={() => handleGetCombo(() => {})}
          handleOnClick={(id) => {
            const selected = comboMemory.findById(id) || undefined
            setCombo(selected)
            setEnableCombo(true)
          }}
        />
      </div>

      {enableCombo && (
        <ComboPopup
          combo={combo}
          title={combo && combo.id !== -1 ? t("title_popup_edite") : t("title_popup_create")}
          onClose={() => handleSwitch(false)}
          onCopy={handleCopyCombo}
        />
      )}

      {enableImport && (
        <ImportDataPopup
          target="combos"
          title={t("dataImport:title", { target: t("dataImport:target_combos") })}
          onClose={() => setEnableImport(false)}
          onImported={() => handleGetCombo(() => {})}
        />
      )}
    </>
  )
}
